// import { useLatest } from "@/hooks/useLatest";
import { type RefObject, useRef } from "react";
import { BaseCanvasRef } from "../components/BaseCanvas";
import {
  createModifyBackgroundAction,
  SetImageAsBackgroundFunction,
  // createModifyBackgroundAction,
  ViewportModificationHandler,
} from "../extensions/backgroundExtension";
import { useSubscribeToSetAsBackgroundImageEvent } from "./event/useSetBackgroundImageEvent";
import { useSubscribeToChangeBackgroundOptionsEvent } from "./event/useChangeBackgroundOptionsEvent";
import { useBackgroundOptions } from "./useBackgroundOptions";
import { prepareViewportAddOrReplaceChange } from "../helpers/viewportHelpers";
import { CanvasDataChange } from "../types/canvasTypes";

export function useBackgroundModification(baseCanvasRef: RefObject<BaseCanvasRef>) {
  const setAsBackgroundImageFunctionRef = useRef<SetImageAsBackgroundFunction>(() => Promise.resolve(null));
  //   const { applyCanvasDataChanges } = useApplyCanvasDataChanges();
  //   const projectRef = useLatest(useCurrentProjectData());
  const { updateBackgroundOptions } = useBackgroundOptions();

  useSubscribeToChangeBackgroundOptionsEvent((payload) => {
    baseCanvasRef.current?.modifyObject(createModifyBackgroundAction(payload));
  });

  useSubscribeToSetAsBackgroundImageEvent(async () => {
    const options = await setAsBackgroundImageFunctionRef.current();

    if (!options) return;
    updateBackgroundOptions(options);
  });

  const initSetAsBackgroundImageFunction = (fn: SetImageAsBackgroundFunction) => {
    setAsBackgroundImageFunctionRef.current = fn;
  };

  const handleViewportModification: ViewportModificationHandler = (viewPort) => {
    applyCanvasDataChanges([prepareViewportAddOrReplaceChange(viewPort)]);
  };

  return { handleViewportModification, initSetAsBackgroundImageFunction };
}

function applyCanvasDataChanges(changes: CanvasDataChange[]) {
  console.log("applyCanvasDataChanges", changes);
}
